export const PERCENT_OPTIONS = [25, 50, 75, 100] as const;
